import { ListStyle } from 'is24-corecss';
import { useIntl } from '@/i18n';

const sections = {
  coverage500: [
    'locksmith',
    'pestControl',
    'waspRemoval',
    'childAndPetCare',
    'electricalEmergency',
    'pipeCleaning',
    'heatingAndPlumbing',
    'householdHelp',
    'accommodation',
    'applianceRepair',
    'burglary',
  ],
  coverage150: ['floorRepair'],
  other: ['legalAdvice', 'tradespersonReferral', 'serviceProviderReferral'],
};

export const OverviewTab = () => {
  const { t } = useIntl();

  return (
    <div style={{ maxWidth: 610 }}>
      <h2 className='font-heading-xsmall-bold margin-bottom-l'>{t({ id: 'benefits.adac.modal.headline' })}</h2>
      <p className='margin-bottom-l'>{t({ id: 'benefits.adac.modal.description' })}</p>
      {Object.entries(sections).map(([section, services]) => (
        <section key={section} className='margin-bottom-l'>
          <h3 className='font-body-medium-bold margin-bottom-s'>
            {t({ id: `benefits.adac.modal.sections.${section}` })}
          </h3>
          <ListStyle variant='checkmark' className='list-spacing-s'>
            {services.map((service) => (
              <ListStyle.Item key={service}>{t({ id: `benefits.adac.modal.services.${service}` })}</ListStyle.Item>
            ))}
          </ListStyle>
        </section>
      ))}
    </div>
  );
};
